import React from 'react';
import { AiOutlineBarChart } from 'react-icons/ai';
import { BsJournalText } from 'react-icons/bs';
import { TbWorld, TbFlask } from 'react-icons/tb';
import { MdOutlineLocationOn } from 'react-icons/md';
import { getLinkIcon } from './linkSubtypeConfig';

export const generateDatumTypeIcon = (datumType, linkSubtype = null) => {
    switch (datumType) {
        case 'definition':
            return <BsJournalText title="Definition" />;
        case 'link':
            return getLinkIcon(linkSubtype || 'website');
        case 'location':
            return <MdOutlineLocationOn title="Location" />;
        case 'ingredient':
            return <TbFlask title="Ingredient / Component" />;
        case 'standard':
        default:
            return <AiOutlineBarChart title="Standard" />;
    }
};

export const generateDatumTypeText = (datumType, linkSubtype = null) => {
    switch (datumType) {
        case 'definition': return 'Definition';
        case 'link': 
            if (linkSubtype) {
                return linkSubtype.charAt(0).toUpperCase() + linkSubtype.slice(1);
            }
            return 'Link';
        case 'location': return 'Location';
        case 'ingredient': return 'Ingredient';
        case 'standard':
        default: return 'Standard';
    }
};